import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@fountain/ui-kit/components/grid';
import Form from '@fountain/ui-kit/components/form';
import Button from '@fountain/ui-kit/components/button';

const propTypes = {
  invalid: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
};

export default function SignInForm({
  handleSubmit,
  invalid,
  submitting,
  submit,
}) {
  return (
    <Form onSubmit={handleSubmit(submit)}>
      <Grid>
        <Grid.Row>
          <Grid.Col sm="12">
            <Form.Input
              fullWidth
              id="email"
              name="email"
              placeholder="Email"
            />
          </Grid.Col>
        </Grid.Row>
        <Grid.Row>
          <Grid.Col sm="12">
            <Form.Password
              fullWidth
              hideStrength
              id="password"
              name="password"
              placeholder="Password"
            />
          </Grid.Col>
        </Grid.Row>
        <Grid.Row>
          <Grid.Col sm="12">
            <Form.Checkbox
              id="remember_me"
              name="remember_me"
            >
              Remember me for 30 days
            </Form.Checkbox>
          </Grid.Col>
        </Grid.Row>
        <Grid.Row>
          <Grid.Col sm="12">
            <Button
              disabled={invalid || submitting}
              type="submit"
            >
              Sign In
            </Button>
          </Grid.Col>
        </Grid.Row>
      </Grid>
    </Form>
  );
}
SignInForm.propTypes = propTypes;
